import {
  CHANGE_LOCALE,
  TENANTS,
  CURRENT_TENANT,
  LOADER
} from '../actions';

export const changeLocale = (locale) => {
  localStorage.setItem('__current_locale', locale);
  document.documentElement.lang = locale;
  return (
    {
      type: CHANGE_LOCALE,
      payload: locale
    }
  )
}

export const setTenants = (payload) => {
  localStorage.setItem('tenants', JSON.stringify(payload));
  return (
    {
      type: TENANTS,
      payload: payload
    }
  )
}

export const setCurrentTenant = (payload) => {
  localStorage.setItem('current_tenant', JSON.stringify(payload));
  return (
    {
      type: CURRENT_TENANT,
      payload: payload
    }
  )
}

export const setLoader = (payload) => {
  return (
    {
      type: LOADER,
      payload: payload
    }
  )
}

